import {routes} from "../../routes/routes";
import { NavLink } from 'react-router-dom';
import {ReactComponent as StatisticsSVG} from '../../../img/icons/statistics.svg';
import {ReactComponent as ScenariosSVG} from '../../../img/icons/scenarios.svg';
import {ReactComponent as InteractionsSVG} from '../../../img/icons/interactions.svg';
import {ReactComponent as ReportsSVG} from '../../../img/icons/reports.svg';
import {ReactComponent as SettingsSVG} from '../../../img/icons/settings.svg';
import {ReactComponent as UserSVG} from '../../../img/icons/user.svg';
import {ReactComponent as KilnLogoSVG} from "../../../img/kiln_logo.svg";
import {ReactComponent as TheVideoGramSVG} from "../../../img/thevideogram.svg";
import useAuth from '../../useAuth';
import useTenant from '../../hooks/useTenant';

const Sidebar = () => {
    const { tenant } = useTenant();
    const { claim } = useAuth();
    const isAdmin = claim?.role === 'admin';

    const navItems = [
        {
            label: 'Statistics',
            to: routes.reports,
            icon: <StatisticsSVG />,
        },
        {
            label: 'Scenarios',
            to: routes.scenarios,
            icon: <ScenariosSVG />,
        },
        {
            label: 'History',
            to: routes.history,
            icon: <ReportsSVG />,
        },
        {
            label: 'Interactions',
            to: routes.interactions,
            icon: <InteractionsSVG />,
            isHidden: !tenant?.showInteractions,
        },
        {
            label: 'Users',
            to: routes.users,
            icon: <UserSVG />,
            isHidden: !isAdmin,
        },
        {
            label: 'Settings',
            to: routes.settings,
            icon: <SettingsSVG />,
            isHidden: !isAdmin,
        },
    ];

    return (
        <aside className="sidebar">
            <div className="sidebar__top">
                <KilnLogoSVG className="sidebar__logo" />
            </div>
            <nav className="sidebar__nav">
                <ul className="nav">
                    {navItems.map((navItem) => {
                        if (navItem.isHidden) {
                            return null;
                        }

                        return (
                            <li className="nav__item" key={navItem.to}>
                                <NavLink
                                    exact
                                    to={navItem.to}
                                    className="nav__link"
                                    activeClassName="nav__link--active"
                                    isActive={(match, location) => {
                                        if (location.pathname.indexOf('/scenarios/') !== -1 && navItem.to === routes.scenarios) {
                                            return true;
                                        }
                                        if (location.pathname.indexOf('/reports/') !== -1 && navItem.to === routes.reports) {
                                            return true;
                                        }
                                        return match;
                                    }}
                                >
                                    {navItem.icon}
                                    {navItem.label}
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </nav>
            <div className="sidebar__footer">
                <a href="https://thevideogram.nl" target="_blank" rel="noopener noreferrer" className="sidebar__footer-link">
                    <TheVideoGramSVG className="sidebar__footer-logo" />
                    <span>KILN is a product of <span className="sidebar__footer-brand">TheVideoGram</span></span>
                </a>
                <span className="sidebar__version">v2.0</span>
            </div>
        </aside>
    )
};

export default Sidebar;
